<template>
    <div id="chat" class="fixed">
        <div class="chat-inner">
            <app-right-panel-header></app-right-panel-header>
            <app-right-panel-teachers></app-right-panel-teachers>
            <app-right-panel-students></app-right-panel-students>

            <!-- <app-languages></app-languages> -->
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import RightPanelHeader from './RightPanelHeader.vue';
    import RightPanelTeachers from './RightPanelTeachers.vue';
    import RightPanelStudents from './RightPanelStudents.vue';
    // import Languages from './Languages'

    export default {
        components: {
            appRightPanelHeader: RightPanelHeader,
            appRightPanelTeachers: RightPanelTeachers,
            appRightPanelStudents: RightPanelStudents,
            // appLanguages: Languages
        },
        data: () => ({

        }),
        computed: {
            ...mapGetters(['view', 'channel'])
        },
    }
</script>
